var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"md":"6","sm":"12"}},[_c('Welcome')],1),_c('v-col',{attrs:{"md":"6","sm":"12"}},[_c('ExpirationNotifications')],1)],1),_c('EuFundLogos')],1)}
var staticRenderFns = []

export { render, staticRenderFns }